import script from "./LongContentPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./LongContentPreview.vue?vue&type=script&lang=ts&setup=true"

import "./LongContentPreview.vue?vue&type=style&index=0&id=899467d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-899467d2"]])

export default __exports__